export enum ProjectType {
    customer = 'customer',
    superadmin = 'superadmin',
    diemaker = 'diemaker',
    printhouse = 'printhouse'
}
